import { Injectable, Input } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-web-storage';
import { LoadingService } from 'src/app/components/loading/loading-service.service';
import { clearMoney } from 'src/app/pipes/pipes.pipe';
import { AlertBarService } from '../alert-bar/alert-bar.service';
import { ApiService } from '../api/api.service';
import { GoogleTagManagerService } from '../google-tag-manager.service';
import { SessionService } from '../session/session.service';
import { GlobalService } from '../global/global.service';

@Injectable({
  providedIn: 'root',
})
export class CalculatorService {
  @Input() valorEmprestimo: any;

  hasSimulation = false;
  hasDefaulter = false;
  hasRefinancing = false;
  hasPeculio = false;
  isTotal = true;
  table: any = [];
  RefinancingContracts: any = [];
  userData: any = [];
  Token: any;
  hasChangeValue = false;
  ValorParcela: any;
  ValorLiquido: any;
  ValorEscolhido: any;
  RefinancingContractsList: any = [];
  setRefinSetAll!: boolean;
  defaultContracts: any = [];
  valorEmprestimoEditable: any;
  editableValue: any;
  withoutMargin!: boolean;
  RefinancingContractsValorTotal = 0;
  SimulacaoKey: any;
  hasContracts = false;
  hasDefaultContracts = false;
  oldValue: any;
  HasReady = false;
  ValorMax: any;
  collapseSlider = false;
  hasRefinancingTotal = false;
  isEdit = false;
  hasRefinDisable = true;
  cacheRefin!: Array<[]>;
  getContractsRetry = 0;
  getContractsMaxRetry = 5;
  routeTo = '';

  constructor(
    private api: ApiService,
    public storage: LocalStorageService,
    private loader: LoadingService,
    private clearMoney: clearMoney,
    private route: Router,
    private toast: AlertBarService,
    private gtmService: GoogleTagManagerService,
    public session: SessionService,
    private gf: GlobalService
  ) {
    this.userData = this.session.getUserData();
    this.Token = this.session.getToken();
  }

  getContracts() {
    this.getContractsRetry++;
    if (this.getContractsRetry == this.getContractsMaxRetry) {
      this.loader.stopLoading();
      this.route.navigate(['/cadastro/ErrorContratacoes']);
      this.gf.toTop();
      return;
    }
    this.api
      .query(
        'auto-contratacao/simularopcoes/' +
          this.userData.CPF +
          '?cpf=' +
          this.userData.CPF +
          '&token=' +
          this.Token,
        {},
        'get'
      )
      ?.subscribe((data: any) => {
        if (data.Sucesso === false) {
          setTimeout(() => {
            this.getContracts();
          }, 2000);
          return;
        }
        if (data.Retorno?.Refinanciamentos?.length > 0) {
          this.hasContracts = true;
          this.hasRefinancing = true;
          this.hasRefinDisable = false;
          this.hasRefinancingTotal = true;

          this.RefinancingContracts = data.Retorno.Refinanciamentos;

          this.RefinancingContractsList = [];

          this.RefinancingContracts.map((c: any) => {
            this.RefinancingContractsList.push(c.CodigoProposta);
            this.RefinancingContractsValorTotal += parseInt(
              c.ValorParcela.replace(/,|[.]|/g, '')
            );
            this.setRefinSetAll = true;
          });

          this.getSimulation('');
        } else {
          this.getSimulation('');
        }

        if (data.Retorno?.EmAtraso?.length > 0) {
          this.storage.set('_cache/contractsDue', data.Retorno.EmAtraso);

          this.hasRefinancing = true;
          this.hasDefaultContracts = true;
          this.hasRefinancingTotal = true;
          this.defaultContracts = data.Retorno.EmAtraso;
          this.hasDefaulter = true;

          let i = 0;
          data.Retorno.EmAtraso.map((c: any) => {
            this.removeDuplicate(c.CodigoProposta);

            this.RefinancingContractsValorTotal += parseInt(
              c.ValorParcela.replace(/,|[.]|/g, '')
            );

            i++;
          });
        }
      });
  }

  getSimulation(value: any) {
    this.loader.startLoading();

    if (value) {
      value = value.toString().slice(0, -2) + '.' + value.toString().slice(-2);
      this.valorEmprestimoEditable = value;
    }

    this.api
      .query(
        'auto-contratacao/simular',
        {
          CPF: this.userData.CPF,
          ValorSolicitado: value ? value : 0,
          ContratosRefinanciamento: this.RefinancingContractsList,
          requisicao: { token: this.Token },
        },
        'post'
      )
      ?.subscribe((data: any) => {
        try {
          if (!!data?.Sucesso !== true) {
            setTimeout(() => {
              this.getContracts();
            }, 2000);
            return;
          }
          this.loader.stopLoading();
          if (data && data.Retorno.Tabelas[0]) {
            this.updateRefins(this.RefinancingContractsList);
            this.SimulacaoKey = data.Retorno.SimulacaoKey;
            this.table = data.Retorno.Tabelas[0];

            const tableCache = data.Retorno.Tabelas[0];
            tableCache.SimulacaoKey = this.SimulacaoKey;

            this.storage.set('_cache/tables', data.Retorno.Tabelas[0]);

            if (value) {
              this.ValorEscolhido = this.clearMoney.transform(
                value.replace('.', '')
              );
            } else {
              if (!this.HasReady) {
                this.ValorLiquido = this.table.ValorLiquido;
                this.ValorParcela = this.table.ValorParcela;
                this.ValorEscolhido = this.table.ValorLiquido;
                this.ValorMax = this.table.ValorLiquido;
              } else {
                this.ValorEscolhido = this.table.ValorLiquido;
                this.ValorMax = this.table.ValorLiquido;
              }
            }

            this.valorEmprestimoEditable = this.clearMoney.transform(
              this.table.ValorLiquido
            );

            if (this.table.ValorPeculio != '0,00') {
              this.hasPeculio = true;
              this.withoutMargin = true;
            }

            this.withoutMargin = false;
            this.HasReady = true;

            if (this.routeTo) this.route.navigate([this.routeTo]);
          } else {
            this.valorEmprestimoEditable = this.clearMoney.transform(
              this.table.ValorLiquido
            );

            if (value) {
              this.toast.openAlert(
                'Não foi encontrada simulação para o valor escolhido. Por favor, tente outro.',
                'error'
              );
              this.SimulacaoKey = '';
              this.ValorEscolhido = this.clearMoney.transform(
                value.replace('.', '')
              );
            } else {
              this.withoutMargin = true;
              this.SimulacaoKey = '';
            }
          }
        } catch (e) {
          this.toast.openAlert(
            'Não foi encontrada simulação para o valor escolhido. Por favor, tente outro.',
            'error'
          );
        }
      });
  }

  confirmSimulation() {
    if (
      parseInt(this.editableValue) >
      parseInt(this.ValorMax.replace(/,|[.]|/g, ''))
    ) {
      this.toast.openAlert('O valor está acima do valor permitido.', 'error');

      return false;
    }

    if (
      parseInt(this.editableValue) <
      parseInt(this.ValorParcela.replace(/,|[.]|/g, ''))
    ) {
      this.toast.openAlert('O valor está abaixo do valor permitido.', 'error');

      return false;
    }

    this.getSimulation(this.editableValue);
    this.hasChangeValue = false;
    this.isEdit = false;

    this.ValorEscolhido = this.editableValue;

    return;
  }

  setRefin(status: any, code: any) {
    if (status) {
      this.RefinancingContractsList.push(code);

      this.RefinancingContracts.map((c: any) => {
        if (c.CodigoProposta == code) {
          this.RefinancingContractsValorTotal += parseInt(
            c.ValorParcela.replace(/,|[.]|/g, '')
          );
        }
      });
    } else {
      this.RefinancingContracts.map((c: any) => {
        if (c.CodigoProposta == code) {
          this.RefinancingContractsValorTotal -= parseInt(
            c.ValorParcela.replace(/,|[.]|/g, '')
          );
        }
      });

      const search_index = this.RefinancingContractsList.indexOf(code);
      if (search_index >= 0) {
        this.RefinancingContractsList.splice(search_index, 1);
      }
    }

    if (
      this.RefinancingContractsList.length == this.RefinancingContracts.length
    ) {
      this.setRefinSetAll = true;
      this.collapseSlider = false;
    } else {
      this.hasContracts = false;
      this.collapseSlider = true;
      this.setRefinSetAll = false;
    }

    this.getSimulation('');

    this.checkRefin();
  }

  setRefinAll(status: any) {
    if (status) {
      this.RefinancingContracts.map((c: any) => {
        this.RefinancingContractsValorTotal += parseInt(
          c.ValorParcela.replace(/,|[.]|/g, '')
        );
        this.setRefinSetAll = true;
        this.RefinancingContractsList.push(c.CodigoProposta);
        this.collapseSlider = false;
      });
    } else {
      this.RefinancingContracts.map((c: any) => {
        this.RefinancingContractsValorTotal -= parseInt(
          c.ValorParcela.replace(/,|[.]|/g, '')
        );
      });

      this.RefinancingContractsList = [];
      this.setRefinSetAll = false;
      this.collapseSlider = true;
    }

    this.getSimulation('');

    this.checkRefin();
  }

  updateRefins(proposals: any) {
    if (proposals.length > 0) {
      this.cacheRefin = [];

      proposals.map((x: number) => {
        this.RefinancingContracts.map((p: any) => {
          if (x == p.CodigoProposta) {
            this.cacheRefin.push(p);
          }
        });
      });

      this.storage.set('_cache/contractsRefin', this.cacheRefin);
    } else {
      this.storage.remove('_cache/contractsRefin');
    }
  }

  checkRefinActive(cod: string) {
    return this.RefinancingContractsList.indexOf(cod) !== -1;
  }

  checkRefin() {
    if (this.RefinancingContractsList.length) {
      this.hasRefinancingTotal = true;
    } else {
      this.hasRefinancingTotal = false;
    }
  }

  sendProposal(key: string) {
    this.gtmService.push({
      event: 'sliderInteraction',
    });

    this.route.navigate(['/resultados']);
  }

  mascaraMoeda(event: any) {
    if (event.target.outerText.length > 13) {
      event.preventDefault();
      return false;
    }

    let s;

    const onlyDigits = event.target.outerText

      .split('')
      .filter((s: any) => /\d/.test(s))
      .join('')
      .padStart(3, '0');

    const digitsFloat = onlyDigits.slice(0, -2) + '.' + onlyDigits.slice(-2);

    this.editableValue = onlyDigits;
    //this.ValorMax = digitsFloat

    event.target.innerHTML =
      "<span class='symbol'>" +
      this.maskCurrency(digitsFloat).slice(0, 2) +
      '</span>' +
      this.maskCurrency(digitsFloat).slice(3, -3) +
      "<span class='cents'>" +
      this.maskCurrency(digitsFloat).slice(-3) +
      '</span>';

    this.moveCursorAtTheEnd(event);

    return;
  }

  maskCurrency(valor: any, locale = 'pt-BR', currency = 'BRL') {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
    }).format(valor);
  }

  moveCursorAtTheEnd(el: any) {
    const selection: any = window.document.getSelection();
    const range = document.createRange();
    const contenteditable: any =
      window.document.querySelector<HTMLInputElement>(
        'div[contenteditable="true"]'
      );

    if (contenteditable.lastChild.nodeType == 3) {
      range.setStart(
        contenteditable.lastChild,
        contenteditable.lastChild.length
      );
    } else {
      range.setStart(contenteditable, contenteditable.childNodes.length);
    }
    selection.removeAllRanges();
    selection.addRange(range);
  }

  removeDuplicate(codigo: string) {
    let i = 0;
    this.RefinancingContracts.map((r: any) => {
      if (r.CodigoProposta == codigo) {
        this.RefinancingContracts.splice(i, 1);

        this.RefinancingContractsValorTotal -= parseInt(
          r.ValorParcela.replace(/,|[.]|/g, '')
        );
      }

      i++;
    });

    if (this.RefinancingContracts.length == 0) {
      this.hasContracts = false;
    }
  }
}
